import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectImportTemplate: {
    id: 'JzTgX6',
    defaultMessage: 'Select Import Template <optionalMessage>(optional)</optionalMessage>',
    description: 'Default message in dropdown menu for selecting import template',
  },
  selectOption: {
    id: 'LTXXFC',
    defaultMessage: 'Select option',
    description: 'Option in dropdown menu for selecting default value',
  },
  dropdownInfoMessage: {
    id: '6UELfo',
    defaultMessage: 'Select or update an import template for faster future CSV imports.',
    description: 'Info message below dropdown menu informing user about the purpose of the dropdown menu',
  },
  manageTemplatesOption: {
    id: 'zCpFxE',
    defaultMessage: 'Manage Import Templates',
    description: 'Option in dropdown menu for managing import templates',
  },
});
